export const STAFF_IMPORT_V1_FORMAT = "GOLF_SCORING_STAFF_V1";

export const STAFF_IMPORT_V1_EXAMPLE = `FORMAT: GOLF_SCORING_STAFF_V1
TURNIEJ: Nazwa turnieju

DOM: Airbnb 1
SCORING ROLA: scoring
AUTO: Trafic ABC123 [9]
OSOBY:
[K] Jan Kowalski
Adam Nowak

DOM: Hotel SCORING
SCORING ROLA: scoring
AUTA WSPÓLNE:
Vivaro XYZ456 [9]
Trafic XYZ789 [9]
OSOBY:
[K] Piotr Nowak
Marcel Kowalski`;

/**
 * Converts the human-readable GOLF_SCORING_STAFF_V1 format to the legacy
 * DOM/ROLA/AUTO format already accepted by the production backend.
 *
 * Keeping this as a compatibility layer means old pasted rosters continue to
 * work unchanged while the UI can expose one stable, copyable format.
 *
 * AUTA WSPÓLNE belongs to the current DOM. For two Airbnbs sharing one physical
 * car, represent them as one transport base, e.g. `DOM: Airbnb 7 + Airbnb 8`.
 */
export function normalizeStaffLogisticsImport(raw: string): string {
  const input = String(raw || "").replace(/\u00a0/g, " ");
  const hasV1Marker = input
    .split(/\r?\n/)
    .some((line) => /^\s*FORMAT\s*:\s*GOLF_SCORING_STAFF_V1\s*$/i.test(line));

  if (!hasV1Marker) return input;

  const output: string[] = [];
  let sharedVehicles = false;

  for (const original of input.split(/\r?\n/)) {
    const line = original.trim();
    if (!line) {
      output.push("");
      continue;
    }

    if (/^FORMAT\s*:/i.test(line) || /^TURNIEJ\s*:/i.test(line)) {
      sharedVehicles = false;
      continue;
    }

    if (/^OSOBY\s*:\s*$/i.test(line)) {
      sharedVehicles = false;
      continue;
    }

    if (/^AUTA\s+WSP[ÓO]LNE\s*:\s*$/i.test(line)) {
      sharedVehicles = true;
      continue;
    }

    const scoringRole = line.match(/^SCORING\s+ROLA\s*:\s*(.+)$/i);
    if (scoringRole) {
      sharedVehicles = false;
      output.push(`ROLA: ${scoringRole[1].trim()}`);
      continue;
    }

    if (/^(?:DOM|NOCLEG|HOTEL|APARTAMENT|ROLA|ROLE|DOJAZD|CZAS DOJAZDU|TRAVEL|AUTO|AUTA|SAMOCH[ÓO]D|SAMOCHODY|VEHICLE)\s*:/i.test(line)) {
      sharedVehicles = false;
      output.push(line);
      continue;
    }

    if (sharedVehicles) {
      output.push(`AUTO: ${line}`);
      continue;
    }

    output.push(line);
  }

  return output.join("\n").trim();
}
